import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router';
import { I18n as I } from 'react-redux-i18n';

import { formatCurrency } from 'vdlib';

import Portlet from '../layout/Portlet';
import Counter from './Counter';
import AuctionStatusCellRenderer from '../tables/datagrid-columns/AuctionStatusCellRenderer';
import BidsCellRenderer from '../tables/datagrid-columns/BidsCellRenderer';

const columns = [
  {
    align: 'center',
    title: I.t('SN'),
    dataIndex: 'ID',
    width: 25,
  },
  {
    title: I.t('DESCRIPTION'),
    dataIndex: 'PartDescription',
    width: 110,
  },
  {
    title: I.t('PART_NO'),
    dataIndex: 'PartNumber',
    align: 'center',
  },
  {
    title: I.t('OFFERS'),
    dataIndex: 'offers',
    width: 50,
    render: (_, record) => <BidsCellRenderer {...record} />,
  },
  {
    title: I.t('BRAND'),
    dataIndex: 'VehicleBrand',
    width: 60,
    align: 'center',
    filterParams: { filterOptions: ['contains'] },
  },
  {
    title: I.t('MODEL'),
    dataIndex: 'VehicleModel',
    width: 70,
    align: 'center',
  },
  {
    title: I.t('STATUS'),
    width: 55,
    align: 'center',
    render: (_, record) => <AuctionStatusCellRenderer {...record} />,
  },
];

const MerchantDashboard = ({
  BiddedAuctions,
  TotalActiveAuctionCount,
  TotalFinishedAuctionAmount,
  TotalForAcceptAuctionAmount,
  TotalForAcceptAuctionCount,
  TotalForDispatchAuctionAmount,
  TotalForDispatchAuctionCount,
}) => {
  const containerClassName = 'col-md-3 col-sm-6 col-12';
  return (
    <div>
      <div className="row">
        <Link to="/auctions" className={containerClassName}>
          <Counter
            colorClassName="blue"
            icon="comments"
            title={I.t('CURRENT')}
            value={TotalActiveAuctionCount}
          />
        </Link>
        <Link to="/auctions/for-acceptance" className={containerClassName}>
          <Counter
            colorClassName="blue"
            icon="comments"
            title={I.t('FOR_ACCEPTANCE')}
            value={TotalForAcceptAuctionCount}
            amount={formatCurrency(TotalForAcceptAuctionAmount)}
          />
        </Link>
        <Link to="/auctions/for-dispatch" className={containerClassName}>
          <Counter
            colorClassName="red"
            icon="truck"
            title={I.t('FOR_DISPATCH')}
            value={TotalForDispatchAuctionCount}
            amount={formatCurrency(TotalForDispatchAuctionAmount)}
          />
        </Link>
        <Link className={containerClassName}>
          <Counter
            colorClassName="green"
            icon="shopping-cart"
            title={I.t('TOTAL_AMOUNT')}
            value={formatCurrency(TotalFinishedAuctionAmount)}
          />
        </Link>
      </div>

      {/* <Portlet title={I.t('OFFERS_TO_AUCTIONS_C')}>
        <Table columns={columns} data={BiddedAuctions} />
      </Portlet> */}
    </div>
  );
};

export default MerchantDashboard;
